<span class="description">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.INBOX_MESSAGE_SENT_TO_VMF.DESCRIPTION' | translate }}
</span>
<glxy-select-input
  [label]="'AUTOMATIONS.EDITOR.TRIGGERS.INBOX_MESSAGE_SENT_TO_VMF.TRIGGER_OPTIONS' | translate"
  [formControl]="triggerStartsControl"
  [required]="true"
  [options]="triggerStartsOptions"
></glxy-select-input>
<glxy-hint class="note">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.INBOX_MESSAGE_SENT_TO_VMF.NOTE' | translate }}
</glxy-hint>
